import Route from "../../../router/Route";
import { RouterView, RouteLocationNormalized } from "vue-router";

import Overview from "../pages/Overview.vue";

export default new Route("testing", "/tests", RouterView, [
	new Route("tesing.index", "", Overview, []),
]);
